import { MultiSelect, MultiSelectOption } from "@/components/ui/multi-select";
import { UniversalContact } from "@/hooks/useUniversalContacts";


interface TaskListMembersSelectorProps {
  contacts: UniversalContact[];
  selectedContactIds: string[];
  onSelectionChange: (selectedIds: string[]) => void;
  getProfileId: (contact: UniversalContact) => string | null;
  placeholder?: string;
}

export function TaskListMembersSelector({ 
  contacts, 
  selectedContactIds, 
  onSelectionChange,
  getProfileId,
  placeholder = "Sélectionner les membres"
}: TaskListMembersSelectorProps) {
  const hasContacts = contacts.length > 0;

  if (!hasContacts) {
    return (
      <div className="text-center py-6 text-muted-foreground">
        <p>Aucun contact disponible</p>
      </div>
    );
  }

  // Include all contacts - we'll handle filtering at the parent level
  const options: MultiSelectOption[] = contacts.map((contact) => ({
    value: contact.id,
    label: contact.displayName,
    avatar: contact.avatar_url,
    group: contact.source === 'family_member' ? 'Famille' : 
          contact.originalData.category === 'family' ? 'Famille' :
          contact.originalData.category === 'friends' ? 'Amis' : 'Autre',
  }));

  return (
    <div>
      <MultiSelect
        options={options}
        selected={selectedContactIds}
        onChange={onSelectionChange}
        placeholder={placeholder}
      />
    </div>
  );
}